// extracted by mini-css-extract-plugin
export default {"container":"styles__container___lbZNo","text":"styles__text___zOr6J","closePanelButton":"styles__closePanelButton___lf6BB"};